export default __webpack_public_path__ + "static/es-a76cdb1a734072589379e99c3602e80e.svg";